import { render, staticRenderFns } from "./PatientQuickForm.vue?vue&type=template&id=010ffe78&scoped=true&lang=pug"
import script from "./PatientQuickForm.vue?vue&type=script&lang=js"
export * from "./PatientQuickForm.vue?vue&type=script&lang=js"
import style0 from "./PatientQuickForm.vue?vue&type=style&index=0&id=010ffe78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010ffe78",
  null
  
)

export default component.exports